import * as React from "react";

import { MyBagPresentationItem } from "../model";

import { useMyBagPresentationModel } from "../providers";

import { FragmentSummaryByTheNumbers } from "../fragment-summary-by-the-numbers";

export const Fragment_Delivery: React.FunctionComponent = (props) => {
  const { presentationMyBagItems } = useMyBagPresentationModel();

  const items = React.useMemo(
    () => (
      <React.Fragment>
        <ul>
          {presentationMyBagItems.map((presentationMyBagItem) => (
            <li key={presentationMyBagItem.id}>
              <Fragment_Delivery_MyBagItem
                presentationMyBagItem={presentationMyBagItem}
              />
            </li>
          ))}
        </ul>
      </React.Fragment>
    ),
    [presentationMyBagItems]
  );
  if (presentationMyBagItems.length < 1) {
    return null;
  }
  return (
    <React.Fragment>
      <p className="number-of-items-in-the-bag">{`${presentationMyBagItems.length} Items in Bag `}</p>

      {items}

      <FragmentSummaryByTheNumbers />
    </React.Fragment>
  );
};

interface Fragment_Delivery_MyBagItemProps {
  presentationMyBagItem: MyBagPresentationItem;
}
const Fragment_Delivery_MyBagItem: React.FunctionComponent<
  Fragment_Delivery_MyBagItemProps
> = (props) => {
  const title = React.useMemo(() => {
    return <p className="title">{props.presentationMyBagItem.title}</p>;
  }, [props.presentationMyBagItem.title]);
  const productImage = React.useMemo(() => {
    return (
      <img
        src={props.presentationMyBagItem.imageThumbnail}
        alt={props.presentationMyBagItem.title}
      />
    );
  }, [
    props.presentationMyBagItem.title,
    props.presentationMyBagItem.imageThumbnail,
  ]);
  const sku = React.useMemo(() => {
    return (
      <p className="sku">
        <span className="item-code-label">{`Item code: `}</span>
        <span className="item-code-sku">{`${props.presentationMyBagItem.sku}`}</span>
      </p>
    );
  }, [props.presentationMyBagItem.sku]);
  const quantity = React.useMemo(() => {
    return (
      <p className="quantity">
        <span className="quantity-label">{`Quantity: `}</span>
        <span className="quantity-value">{`${props.presentationMyBagItem.howManyOfThisProduct}`}</span>
      </p>
    );
  }, [props.presentationMyBagItem.howManyOfThisProduct]);
  const total = React.useMemo(() => {
    return (
      <div className="total">
        <p className="preamble">{`Total Price:`}&nbsp;</p>
        <Fragment_Delivery_ProductSubtotal
          value={props.presentationMyBagItem}
        />
      </div>
    );
  }, [props.presentationMyBagItem]);

  return (
    <div className="my-bag-item">
      <div className="lhs">{productImage}</div>
      <div className="rhs">
        {title}
        {sku}
        {quantity}
        {total}
      </div>
    </div>
  );
};

interface Fragment_Delivery_ProductSubtotalProps {
  value: MyBagPresentationItem;
}
const Fragment_Delivery_ProductSubtotal: React.FunctionComponent<
  Fragment_Delivery_ProductSubtotalProps
> = (props) => {
  return (
    <div
      className={`item-subtotal ${
        props.value.isMemberPrice
          ? "member-pricing"
          : props.value.isSalePrice
          ? "sale-pricing"
          : "regular-pricing"
      }`}
    >
      {(props.value.isMemberPrice || props.value.isSalePrice) && (
        <p
          className={`the-price-afterwards
            ${
              props.value.isMemberPrice
                ? "the-member-price"
                : props.value.isSalePrice
                ? "the-sale-price"
                : "never"
            }
          `}
        >
          <span className="dollar-sign">{`\$`}</span>
          <span className="actual-value">
            {`${props.value.subtotal.toFixed(2)}`}
          </span>
        </p>
      )}
      <p
        className={`the-regular-price ${
          props.value.isMemberPrice || props.value.isSalePrice
            ? "the-normally-price"
            : ""
        }`}
      >
        <span className="dollar-sign">{`\$`}</span>
        <span className="actual-value">
          {`${
            props.value.isMemberPrice || props.value.isSalePrice
              ? props.value.subtotalNormally.toFixed(2)
              : props.value.subtotal.toFixed(2)
          }`}
        </span>
      </p>
    </div>
  );
};
